import { useEffect, useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useDeals } from "../../CustomHooks/Queries";
import { isBattlecardFlowProtectedRoute } from "../../Utils/helpers";

export default function BattlecardRouteGuard() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const { isLoading: isLoadingDeals } = useDeals();

  const accessState = useMemo(() => {
    if (isLoadingDeals) return "loading";

    if (isBattlecardFlowProtectedRoute(pathname)) {
      return location.state?.battlecardFlow === true ? "allowed" : "denied";
    }

    return "denied";
  }, [isLoadingDeals, location.state?.battlecardFlow, pathname]);

  useEffect(() => {
    if (accessState === "loading") return;

    if (accessState === "denied") {
      navigate("/home", { replace: true });
    }
  }, [accessState, navigate]);

  if (accessState !== "allowed") {
    return <div className="battle-cards-page" />;
  }

  return <Outlet />;
}

